import {DroppingOddsReducer, ReducerFromState} from "../../../@types/reducers";
import {DoClassicSettingsObject} from "../../../@types/response";


export const getClassicSettings = (state: ReducerFromState<DroppingOddsReducer>): DoClassicSettingsObject => state.odds.classicSettings;

